import React, { useState, useEffect } from 'react';
import api from '../../api/client';
import { errMsg } from '../../utils/helpers';
import { Modal, Field, Spinner } from './UI';
import toast from 'react-hot-toast';

// Простой нативный select без обёртки
function NativeSelect({ value, onChange, options, placeholder }) {
  return (
    <select
      className="input"
      value={value}
      onChange={e => onChange(e.target.value)}
    >
      <option value="">{placeholder || 'Выберите...'}</option>
      {options.map(o => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}

export function PaymentModal({ entityType, entityId, dealerId, onClose, onDone }) {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    amount: '',
    payer_company_id: '',
    receiver_company_id: '',
    doc_number: '',
    doc_date: '',
    payment_date: '',
    note: '',
    direction: 'in',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/admin/companies')
      .then(({ data }) => { setCompanies(data); })
      .catch(() => toast.error('Не удалось загрузить компании'))
      .finally(() => setLoading(false));
  }, []);

  const isSupply = entityType === 'supply';

  // Фильтруем: плательщик = компании нужного дилера, получатель = мои
  const payerOpts = companies
    .filter(c => dealerId ? c.dealer_id === +dealerId : !!c.dealer_id)
    .map(c => ({ value: String(c.id), label: c.name }));

  const receiverOpts = companies
    .filter(c => !c.dealer_id)
    .map(c => ({ value: String(c.id), label: c.name }));

  // Для поставки — все компании
  const allOpts = companies.map(c => ({
    value: String(c.id),
    label: c.name + (c.dealer_id ? ' [Д]' : ' [П]'),
  }));

  const payerOptsResult   = isSupply ? allOpts : (payerOpts.length   ? payerOpts   : allOpts);
  const receiverOptsResult = isSupply ? allOpts : (receiverOpts.length ? receiverOpts : allOpts);

  const set = (field) => (val) => setForm(f => ({ ...f, [field]: val }));

  const save = async () => {
    if (!form.amount) { toast.error('Укажите сумму'); return; }
    setSaving(true);
    try {
      await api.post('/' + entityType + 's/' + entityId + '/payments', {
        ...form,
        payer_company_id:    form.payer_company_id    || null,
        receiver_company_id: form.receiver_company_id || null,
        doc_date:            form.doc_date    || null,
        payment_date:        form.payment_date || null,
      });
      toast.success('Платёж добавлен');
      onDone();
      onClose();
    } catch (err) { toast.error(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Modal title="Добавить платёж" onClose={onClose} size="sm">
      {loading ? (
        <div className="flex justify-center py-8"><Spinner /></div>
      ) : (
        <div className="space-y-3">
          {isSupply && (
            <Field label="Направление">
              <NativeSelect value={form.direction} onChange={set('direction')}
                options={[
                  { value: 'in',  label: '↓ Входящий (от дилера)' },
                  { value: 'out', label: '↑ Исходящий (поставщику)' },
                ]} />
            </Field>
          )}

          <Field label="Сумма, ₽" required>
            <input type="number" className="input" value={form.amount} autoFocus
              onChange={e => setForm(f => ({ ...f, amount: e.target.value }))} />
          </Field>

          <Field label="Плательщик">
            <NativeSelect value={form.payer_company_id} onChange={set('payer_company_id')}
              options={payerOptsResult} placeholder="— выберите —" />
          </Field>

          <Field label="Получатель">
            <NativeSelect value={form.receiver_company_id} onChange={set('receiver_company_id')}
              options={receiverOptsResult} placeholder="— выберите —" />
          </Field>

          <div className="grid grid-cols-2 gap-3">
            <Field label="№ документа">
              <input className="input mono" value={form.doc_number} placeholder="Необязательно"
                onChange={e => setForm(f => ({ ...f, doc_number: e.target.value }))} />
            </Field>
            <Field label="Дата документа">
              <input type="date" className="input" value={form.doc_date}
                onChange={e => setForm(f => ({ ...f, doc_date: e.target.value }))} />
            </Field>
          </div>

          <Field label="Дата платежа">
            <input type="date" className="input" value={form.payment_date}
              onChange={e => setForm(f => ({ ...f, payment_date: e.target.value }))} />
          </Field>

          <Field label="Примечание">
            <input className="input" value={form.note}
              onChange={e => setForm(f => ({ ...f, note: e.target.value }))} />
          </Field>

          <div className="flex justify-end gap-2 pt-2">
            <button className="btn-secondary" onClick={onClose}>Отмена</button>
            <button className="btn-primary" onClick={save} disabled={saving}>
              {saving ? <Spinner size={14} /> : 'Добавить'}
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
